export function getBreakpointSize() {
  let size = 'L';
  if (window.matchMedia('(max-width: 600px)')?.matches) {
    size = 'S';
  } else if (window.matchMedia('(max-width: 900px)')?.matches) {
    size = 'M'
  }

  return size;
}

export function findParent(element, selector) {
  if (!element) {
    return null;
  }
  if (element.matches(selector)) {
    return element;
  }
  return findParent(element.parentElement, selector);
}

export function safeParseJson(string) {
  try {
    return JSON.parse(string);
  } catch(error) {
    console.warn(`could not parse json: ${string}`);
  }
}

export function debounce(func, delay = 500) {
  let timeout;
  return function(...args) {
    clearTimeout(timeout);
    timeout = setTimeout(
      () => {
        timeout = null;
        func(...args);
      },
      delay
    );
  };
}
